define(
    'extensions/knockout/fp_list_grid',[
        "viewmodels/secured/explorer/context",
        "extensions/kendo.extensions"
    ], function (ctx, kendoExt) {

        ko.bindingHandlers["fp_list_grid"] = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
                var unwrap = ko.utils.unwrapObservable;

                var bindingDetails = unwrap(valueAccessor()) || {};
                var list = bindingDetails.list;
                var selected = bindingDetails.selected || function () { };

                var options = {
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    selectable: false,
                    change: selected,
                    //TODO: 21-Oct-2013 - Ben - Adding the virtual scrolling removes the kendoMobileScroller used later on for position the selected row when changing filters. Figure out how to fix.
                    //                scrollable: {
                    //                    virtual: true
                    //                },
                    dataBound: function (args) {
                        var grid = args.sender;
                        var items = grid.dataSource.data();
                        _.each(items, function (item) {
                            var row = grid.tbody.find("tr[data-uid='" + item.uid + "']");
                            row.attr("data-lvid", item.listValueId);
                        });
                        
                        var dataItem = ctx.current.listValue ? ctx.current.listValue : bindingDetails.selectedRow();
                        if (dataItem) {
                            var $row = grid.table.find('tr[data-lvid="' + dataItem.listValueId + '"]');

                            var $iconAccess = $row.find("i.access"); $iconAccess.show();
                            var $iconEdit = $row.find("i.edit"); $iconEdit.show();
                            var $iconDelete = $row.find("i.delete"); $iconDelete.show();
                        }                        
                        
                        var $mnu = grid.table.find("tr[data-lvid='00000000-0000-0000-0000-000000000000']");
                        $mnu.replaceWith('<tr data-uid="00000000-0000-0000-0000-000000000000" data-lvid="00000000-0000-0000-0000-000000000000" role="row"><td role="gridcell"><i class="fa fa-folder-open-o"></i></td><td colspan="' + (grid.columns.length - 2) + '" style="padding:0;line-height:31px;cursor:pointer;"><span style="margin-left:7px;">Folder Template</span></td><td role="gridcell"></td></tr>');
                    },
                    toolbar: kendo.template($(element).closest("#library-container").find("#filter-template").html()),
                };

                $.extend(options, bindingDetails.options || {});

                var grid, initialized, data;

                list.active.selectGridRow = function (id) {
                    var grid2 = $(element).data("kendoGrid");
                    var row = grid2.tbody.find("tr[data-lvid='" + id + "']");

                    //row.addClass("k-state-selected");

                    $(row).trigger("click");
                };
                
                list.active.values.subscribe(function (newValue) {
                    data = newValue;

                    if (!initialized) {
                        initialized = true;
                        options.columns = kendoExt.grid.addColumnTemplateFormatters(list.schema());
                        attachFollowListValueTemplate(options.columns);
                        if (list.isAdmin) attachActionListValueTemplate(options.columns);

                        options.dataSource = {
                            transport: {
                                read: function (callbacks) {
                                    if (list.isAdmin) {
                                        var b = _.find(data, function (itm) { return itm.listValueId == "00000000-0000-0000-0000-000000000000"; });
                                        if (!b) {
                                            data.unshift({ listValueId: "00000000-0000-0000-0000-000000000000", following: false, Code: "", Description: "", label: "" });
                                        }
                                    }

                                    callbacks.success(data);                                   
                                }
                            },
                            //pageSize: 50 //TODO: 21-Oct-2013 - Ben - this is part of the virtual scroller. add back in when that has been solved.
                        };
                        
                        try {
                            options.columns[0].width = 30;
                            if (options.columns.length == 3) {
                                options.columns[1].width = 200;
                            }
                            if (options.columns.length > 3) {
                                options.columns[1].width = 95;
                                options.columns[2].width = 180;
                            }
                        }
                        catch(ex) { }
                        
                        grid = $(element).kendoGrid(options).data("kendoGrid");

                        // bind the filter control now that it has been attached to the DOM.
                        //var $listFilter = $(element).find(".filter-box"); filterItem
                        var $listFilter = $(element).find(".filterItem");
                        ko.applyBindings(ko.contextFor($listFilter[0]), $listFilter[0]);                        
                        
                        $listFilter.find("input.form-control").attr("placeholder", "Filter in " + list.listName);

                        ////this, because webapi library does not return listName
                        //require(["viewmodels/secured/explorer/context", "providers/dataprovider"], function (ctx, dataProvider) {
                        //    if (ctx.current && ctx.current.library) {
                        //        dataProvider.libraries
                        //        .getSettings(ctx.current.library.libraryId)
                        //        .done(function (data) {
                        //            $listFilter.find("input.form-control").attr("placeholder", "Filter in " + data.listName);
                        //        })
                        //        .fail(function (e) {
                        //            console.error(e);
                        //        });
                        //    }
                        //});

                        grid.table.on("click", "tr", toggleSelect);
                        grid.table.on("click", "i.following", toggleFollowing);
                        grid.table.on("click", "i.access", toggleAccess);
                        grid.table.on("click", "i.edit", toggleEdit);
                        grid.table.on("click", "i.delete", toggleDelete);

                        $(element).resizable({
                            handles: "s", // south
                            minHeight: 200,
                            helper: "resize-helper",
                            stop: function (event, ui) {
                                $(element).css("width", "initial");
                                grid.refresh();
                            }
                        });
                        var debouncedFilter = _.debounce(function () { filter.call(this); }, 400);
                        $("input", $listFilter).on("keyup", debouncedFilter);
                        $(element).find("#nav-search-icon-clear").click(function (e) {
                            $("input", $listFilter).val("");
                            filter.call(this);
                        });
                        
                    } else {                        
                        grid.dataSource.read();
                        grid.refresh();

                        var dataItem = ctx.current.listValue ? ctx.current.listValue : bindingDetails.selectedRow();
                        var scrollToPosition = 0;
                        if (dataItem && dataItem.listValueId) {                            
                            var $row = grid.tbody.find("tr[data-lvid='" + dataItem.listValueId + "']");
                            if ($row.length) {
                                $row.addClass('k-state-selected');
                                scrollToPosition = $row.position().top;
                            }
                        }
                        if (kendo.support.mobileOS) {
                            var scroller = grid.wrapper.find(".k-grid-content").data("kendoMobileScroller");
                            scroller.scrollTo(0, -scrollToPosition);
                        } else {
                            grid.content.animate({ scrollTop: scrollToPosition }, 200);
                        }
                    }
                });

                function filter() {
                    var value = this.value;

                    if (!value || value == "") {

                        grid.dataSource.filter([]);

                        return;
                    }

                    var filteredColumns = _.filter(grid.options.columns, function (column) { return column.field; });
                    var filters = _.map(filteredColumns, function (column) {
                        return {
                            field: column.field,
                            operator: function (item, val) {
                                var searchText = "";

                                if (item instanceof kendo.data.ObservableArray && column.type.toLowerCase() == "foreignkey") {
                                    _.each(item, function (arrayItem) {
                                        searchText += arrayItem.label + " ";
                                    });
                                } else {
                                    searchText = column.formatter ? kendo.toString((item ? item.toString() : ""), column.formatter) : (item ? item.toString() : "");
                                }
                           
                                return item != null && searchText.toLowerCase().indexOf(val.toLowerCase()) >= 0;
                            },
                            value: value //String.format("'{0}'", value)
                        };
                    });
                                      
                    grid.dataSource.filter({
                        logic: "or",
                        filters: filters
                    });
                }

                function attachFollowListValueTemplate(columns) {
                    columns.unshift({
                        template: kendo.template($("#fp-list-grid-following-template").html()),
                        width: columns.length > 2 ? 30 : 10,
                        resizable: false
                    });
                }
                function attachActionListValueTemplate(columns) {
                    columns.push({
                        template: kendo.template($("#fp-list-grid-action-template").html()),
                        width: 75,
                        resizable: false
                    });
                }

                function toggleSelect(e) {
                    //var prev = grid.table.find("tr.k-state-selected").length;
                    //if (prev) {
                        //var $row = $(grid.table.find("tr.k-state-selected"));
                        //var $icon = $row.find("i.following");
                        
                        //$icon.css("color", "#6b9dd9");
                    //}

                    grid.table.find("tr i.access").hide();
                    grid.table.find("tr i.edit").hide();
                    grid.table.find("tr i.delete").hide();
                    grid.table.find("tr.k-state-selected").removeClass("k-state-selected"); // remove existing.

                    var $row = $(this); $row.addClass("k-state-selected");
                    var dataItem = grid.dataItem($row);                    
                    
                    if (dataItem.listValueId !== "00000000-0000-0000-0000-000000000000") {
                        var $iconAccess = $row.find("i.access"); $iconAccess.show();
                        var $iconEdit = $row.find("i.edit"); $iconEdit.show();
                        var $iconDelete = $row.find("i.delete"); $iconDelete.show();
                    }

                    //var $icon = $row.find("i.following");
                    //$icon.css("color", "white");                   
                    
                    selected(dataItem.toJSON());
                }
                function toggleAccess(e) {

                    if (list) {
                        var dataItem = bindingDetails.selectedRow();
                        if (dataItem && dataItem.listValueId) {
                            list.accessControl(dataItem.listValueId);
                        }
                    }

                    e.stopPropagation();
                    return false;
                }
                function toggleEdit(e) {
                    
                    if (list) {
                        var dataItem = bindingDetails.selectedRow();
                        if (dataItem && dataItem.listValueId) {
                            list.editItem(dataItem.listValueId);
                        }
                    }

                    e.stopPropagation();
                    return false;
                    //var $row = $(this);
                    //var dataItem = grid.dataItem($row);

                    //console.warn($row);
                    //console.warn(dataItem);

                    //dataItem.addItem();

                    ////var rowPos = $row.position();
                    ////var bottomTop = rowPos.top;
                    ////var bottomLeft = rowPos.left;

                    ////console.warn(rowPos);

                    //////$divOverlay.css({
                    //////    position: 'absolute',
                    //////    top: bottomTop,
                    //////    left: bottomLeft,
                    //////    width: bottomWidth,
                    //////    height: bottomHeight
                    //////});
                }
                function toggleDelete(e) {
                    if (list) {

                        var dataItem = bindingDetails.selectedRow();
                        if (dataItem && dataItem.listValueId) {
                            list.deleteItem(dataItem.listValueId);
                        }
                    }

                    e.stopPropagation();
                    return false;
                }
                function toggleFollowing(e) {
                    var $icon = $(this);
                    var $row = $(this).closest("tr");
                    var dataItem = grid.dataItem($row);
                    var iconSelected = $icon.hasClass("fa-star");

                    // Note: 24-Jul-2013 - Ben - would like to have used a binding but when updating the field the isDirty field changes and the grid removes the currently selected highlighted row.
                    //dataItem.set("following", !iconSelected);

                    // instead you get this...
                    if (iconSelected)
                        $icon.removeClass("fa-star").addClass("fa-star-o");
                    else
                        $icon.removeClass("fa-star-o").addClass("fa-star");

                    list.updateIsFollowing(dataItem.listValueId, !iconSelected);
                    e.stopPropagation();
                }
            }
        };

    });
